export function escapeHtml (text) {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
}

export function questionLabels () {
  // On the settings page the question rows live on a separate route, so the
  // labels are seeded server-side; fall back to the live inputs when the
  // question editor is on the same page (the create wizard / questions page).
  const seed = document.querySelector('[data-question-labels]')
  if (seed) {
    try {
      return JSON.parse(seed.getAttribute('data-question-labels')).map((l) => l.trim()).filter(Boolean)
    } catch (e) {
      return []
    }
  }

  return Array.from(document.querySelectorAll('[data-field-row-target="label"]'))
    .filter((el) => {
      const row = el.closest("[data-form-fields-target~='row']")
      return row && !row.classList.contains('hidden')
    })
    .map((el) => el.value.trim())
    .filter(Boolean)
}

export function knownLabels () {
  return new Set(questionLabels().map((label) => label.toLowerCase()))
}
